import api from './api';

/**
 * Serviço para gerenciar operações relacionadas a casais
 */

// Obter informações do casal atual do usuário
export const getMyCouple = async () => {
  try {
    console.log('Chamando API para buscar casal do usuário:', `${api.defaults.baseURL}/couples/my-couple`);
    const response = await api.get('/couples/my-couple');
    console.log('Resposta da API (meu casal):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar casal do usuário:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Criar um novo casal
export const createCouple = async (coupleData) => {
  try {
    console.log('Chamando API para criar casal:', `${api.defaults.baseURL}/couples/create`);
    console.log('Dados do casal:', coupleData);
    const response = await api.post('/couples/create', coupleData);
    console.log('Resposta da API (criar casal):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar casal:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Enviar convite para parceiro
export const invitePartner = async (email, message = '') => {
  try {
    console.log('Chamando API para enviar convite:', `${api.defaults.baseURL}/couples/invite`);
    console.log('Email do convidado:', email);
    const response = await api.post('/couples/invite', { email, message });
    console.log('Resposta da API (enviar convite):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao enviar convite:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Obter detalhes de um convite
export const getInvitationDetails = async (token) => {
  try {
    console.log('Chamando API para obter detalhes do convite:', `${api.defaults.baseURL}/couples/invitation/${token}`);
    const response = await api.get(`/couples/invitation/${token}`);
    console.log('Resposta da API (detalhes do convite):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter detalhes do convite:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Aceitar convite de casal
export const acceptInvitation = async (token, nickname = '') => {
  try {
    console.log('Chamando API para aceitar convite:', `${api.defaults.baseURL}/couples/join/${token}`);
    console.log('Nickname:', nickname);
    const response = await api.post(`/couples/join/${token}`, { nickname });
    console.log('Resposta da API (aceitar convite):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao aceitar convite:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Atualizar configurações do casal
export const updateCoupleSettings = async (settings) => {
  try {
    console.log('Chamando API para atualizar configurações do casal:', `${api.defaults.baseURL}/couples/settings`);
    console.log('Configurações:', settings);
    const response = await api.put('/couples/settings', settings);
    console.log('Resposta da API (atualizar configurações):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar configurações do casal:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Sair do casal
export const leaveCouple = async () => {
  try {
    console.log('Chamando API para sair do casal:', `${api.defaults.baseURL}/couples/leave`);
    const response = await api.delete('/couples/leave');
    console.log('Resposta da API (sair do casal):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao sair do casal:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Obter conflitos compartilhados do casal
export const getCoupleConflicts = async (page = 1, limit = 10) => {
  try {
    console.log('Chamando API para buscar conflitos do casal:', `${api.defaults.baseURL}/couples/conflicts`);
    const response = await api.get('/couples/conflicts', {
      params: { page, limit }
    });
    console.log('Resposta da API (conflitos do casal):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar conflitos do casal:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Obter estatísticas do casal
export const getCoupleStats = async () => {
  try {
    console.log('Chamando API para buscar estatísticas do casal:', `${api.defaults.baseURL}/couples/stats`);
    const response = await api.get('/couples/stats');
    console.log('Resposta da API (estatísticas do casal):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas do casal:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Compartilhar conflito com o casal
export const shareConflictWithCouple = async (conflictId) => {
  try {
    console.log('Chamando API para compartilhar conflito:', `${api.defaults.baseURL}/conflicts/${conflictId}/share`);
    const response = await api.post(`/conflicts/${conflictId}/share`);
    console.log('Resposta da API (compartilhar conflito):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao compartilhar conflito:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Remover compartilhamento de conflito
export const unshareConflict = async (conflictId) => {
  try {
    console.log('Chamando API para remover compartilhamento:', `${api.defaults.baseURL}/conflicts/${conflictId}/unshare`);
    const response = await api.post(`/conflicts/${conflictId}/unshare`);
    console.log('Resposta da API (remover compartilhamento):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao remover compartilhamento:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Tornar conflito privado
export const setConflictPrivate = async (conflictId, isPrivate = true) => {
  try {
    console.log('Chamando API para alterar privacidade do conflito:', `${api.defaults.baseURL}/conflicts/${conflictId}/privacy`);
    const response = await api.post(`/conflicts/${conflictId}/privacy`, { isPrivate });
    console.log('Resposta da API (alterar privacidade):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao alterar privacidade do conflito:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Conceder acesso específico a conflito
export const grantConflictAccess = async (conflictId, userId, permission = 'read') => {
  try {
    console.log('Chamando API para conceder acesso ao conflito:', `${api.defaults.baseURL}/conflicts/${conflictId}/access`);
    const response = await api.post(`/conflicts/${conflictId}/access`, { userId, permission });
    console.log('Resposta da API (conceder acesso):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao conceder acesso ao conflito:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Revogar acesso a conflito
export const revokeConflictAccess = async (conflictId, userId) => {
  try {
    console.log('Chamando API para revogar acesso ao conflito:', `${api.defaults.baseURL}/conflicts/${conflictId}/access`);
    const response = await api.delete(`/conflicts/${conflictId}/access`, { 
      data: { userId } 
    });
    console.log('Resposta da API (revogar acesso):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao revogar acesso ao conflito:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Verificar se pode convidar um email específico
export const checkInviteEligibility = async (email) => {
  try {
    console.log('Chamando API para verificar elegibilidade de convite:', `${api.defaults.baseURL}/couples/check-eligibility`);
    const response = await api.post('/couples/check-eligibility', { email });
    console.log('Resposta da API (verificar elegibilidade):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar elegibilidade:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Cancelar convite pendente
export const cancelInvitation = async (email) => {
  try {
    console.log('Chamando API para cancelar convite:', `${api.defaults.baseURL}/couples/cancel-invite`);
    const response = await api.post('/couples/cancel-invite', { email });
    console.log('Resposta da API (cancelar convite):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao cancelar convite:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

export default {
  getMyCouple,
  createCouple,
  invitePartner,
  getInvitationDetails,
  acceptInvitation,
  updateCoupleSettings,
  leaveCouple,
  getCoupleConflicts,
  getCoupleStats,
  shareConflictWithCouple,
  unshareConflict,
  setConflictPrivate,
  grantConflictAccess,
  revokeConflictAccess,
  checkInviteEligibility,
  cancelInvitation
};